import Vue from 'vue'
import './config.js'
import store from '@/vuex/store'
import Router from '@/router'
import '@/components'
import '@/directives'
import '@/style/index.css'
import 'babel-polyfill'
import '@vant/touch-emulator'

// import './assets/icon/'
import App from './App'

// window.baseUrlPath = process.env.NODE_ENV === 'production' ? `${window.location.origin}` : `${process.env.VUE_APP_DEV_SERVER}/${BASE_PROJECT}`
const router = new Router()

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

Vue.config.productionTip = false

export {
  router,
  store,
}
